import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import type { ListItemModalProps } from '@atlassian/jira-software-roadmap-timeline-table/src/renderers/index.tsx';
import type { OnJiraItemUpdate } from '../../../controllers/update-item/types.tsx';
import { EDIT_DATES, EDIT_DEPENDENCY } from '../constants.tsx';
import { AsyncEditDatesModal } from './edit-dates-modal/async.tsx';
import EditDependencyModal from './edit-dependency-modal/index.tsx';

type Props = ListItemModalProps & {
	onItemUpdate: OnJiraItemUpdate;
};

const ListItemModal = ({ id, optionId, triggerRef, onItemUpdate, setCloseModal }: Props) => {
	switch (optionId) {
		case EDIT_DATES:
			return fg('jwm_timeline_meatballs_date_update') ? (
				<AsyncEditDatesModal
					id={id}
					isOpen
					setCloseModal={setCloseModal}
					triggerRef={triggerRef}
					onItemUpdate={onItemUpdate}
				/>
			) : null;

		case EDIT_DEPENDENCY:
			return fg('jwm_timeline_meatballs_edit_dependency') ? (
				<EditDependencyModal id={id} isOpen setCloseModal={setCloseModal} triggerRef={triggerRef} />
			) : null;
		default:
			return null;
	}
};

export default ListItemModal;
